import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  benefitFreeShippingInactiveTitle: {
    id: 'checkout.cartPage.benefitFreeShippingInactiveTitle',
    defaultMessage: 'Free shipping next time?',
    description: 'Message for the customer in the benefits section.',
  },
  benefitFreeShippingActiveTitle: {
    id: 'checkout.cartPage.benefitFreeShippingActiveTitle',
    defaultMessage: 'Shipping {overPriceSection} is free <normal>till</normal> {date}. ',
    description: 'Message for the customer in the benefits section.',
  },

  benefitOverPriceTitle: {
    id: 'checkout.cartPage.benefitOverPriceTitle',
    defaultMessage: 'over {price}',
    description: 'Message for the customer in the benefits section.',
  },

  benefitFreeShippingActiveReactivationDescription: {
    id: 'checkout.cartPage.benefitFreeShippingActiveReactivationDescription',
    defaultMessage: 'If you buy again over {price} extend your free shipping until {date}. {link}',
    description: 'Description for information message in the benefits section.',
  },

  benefitFreeShippingBuyForMoreDescription: {
    id: 'checkout.cartPage.benefitFreeShippingBuyForMoreDescription',
    defaultMessage: 'Buy for {price},',
    description: 'Message for the customer in the benefits section.',
  },

  benefitFreeShippingRegisterDescription: {
    id: 'checkout.cartPage.benefitFreeShippingRegisterDescription',
    defaultMessage: 'register,',
    description: 'Message for the customer in the benefits section.',
  },

  benefitFreeShippingSubscribeDescription: {
    id: 'checkout.cartPage.benefitFreeShippingSubscribeDescription',
    defaultMessage: 'subscribe to our newsletter,',
    description: 'Message for the customer in the benefits section.',
  },

  benefitFreeShippingConditionDescription: {
    id: 'checkout.cartPage.benefitFreeShippingConditionDescription',
    defaultMessage: '{buyForMoreSection} {registerSection} {subScribeSection}',
    description: 'Message for the customer in the benefits section.',
  },

  benefitFreeShippingConditionsToBeMetDescription: {
    id: 'checkout.cartPage.benefitFreeShippingGetBenefitByForAmount',
    defaultMessage: '{conditionSection} and get free shipping for the next six months.',
    description:
      'If the customer is not already subscribed to the newsletter, it displays a message in the benefits section.',
  },

  benefitFreeShippingCompletePurchase: {
    id: 'checkout.cartPage.benefitFreeShippingCompletePurchase',
    defaultMessage: 'Complete your purchase and get free shipping for the next six months.',
    description: 'Used in link.',
  },

  benefitFreeShippingMoreInformation: {
    id: 'checkout.cartPage.benefitFreeShippingMoreInformation',
    defaultMessage: 'More information',
    description: 'Used in link.',
  },

  benefitFreeShippingTermsAndConditions: {
    id: 'checkout.cartPage.benefitFreeShippingTermsAndConditions',
    defaultMessage:
      'The claim to the benefit of free shipping arises only after receiving the first order over £{price}.',
    description: 'Additional info for customer when the benefit gets activated.',
  },
});
